import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	filtersControls: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: theme.spacing.small,
	},
	filtersControlsLeft: {
		display: 'flex',
		flex: 'none',
		marginRight: 'auto',
		flexDirection: 'column',
		justifyContent: 'center',
		width: '100%',
		[getFromBreakpoint('sm')]: {
			width: 'auto',
		},
	},
	totalSkeleton: {
		display: 'flex',
		marginTop: theme.spacing.tiny,
		width: '210px',
		justifyContent: 'space-between',
	},
	optionsList: {
		paddingBottom: theme.spacing.xsmall,
	},
	sortOption: {
		paddingTop: '6px', // no spacing token for 6px
		paddingBottom: '6px', // no spacing token for 6px
		fontSize: theme.fontSize.xSmall,
		color: theme.palette.neutral['60'],
		lineHeight: theme.lineHeight.spacious,
	},
	selectedSortOption: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	checkmark: {
		color: theme.primary.color.default,
	},
	applyButton: {
		width: '100%',
	},
}));
